import { FC, MouseEventHandler } from 'react';

import { Link } from 'dibs-elements/exports/Link';
import ArrowLeft from 'dibs-icons/exports/ArrowLeft';
import ArrowRight from 'dibs-icons/exports/ArrowRight';
import classnames from 'classnames';

import styles from './PhotoArrowOverlay.scss';

type Props = {
    hidePrevArrow?: boolean;
    hideNextArrow?: boolean;
    onNextClick: MouseEventHandler<HTMLDivElement>;
    onPrevClick: MouseEventHandler<HTMLDivElement>;
};

const LeftArrow: FC<Props> = props => {
    return (
        <Link
            className={classnames(styles.leftArrowBox, { [styles.inactive]: props.hidePrevArrow })}
            onClick={props.onPrevClick}
        >
            <ArrowLeft className={styles.arrow} />
        </Link>
    );
};

const RightArrow: FC<Props> = props => {
    return (
        <Link
            className={classnames(styles.rightArrowBox, { [styles.inactive]: props.hideNextArrow })}
            onClick={props.onNextClick}
        >
            <ArrowRight className={styles.arrow} />
        </Link>
    );
};

const PhotoArrowOverlay: FC<Props> = props => (
    <div className={styles.wrapper}>
        <LeftArrow {...props} />
        <RightArrow {...props} />
    </div>
);

export default PhotoArrowOverlay;
